import { Routes } from '@angular/router';
import { vacantesFiltradasRoute } from './core/routing/vacantes.matcher';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
    title: 'Chambia — Consigue chamba por WhatsApp',
  },
  {
    path: 'empresas',
    loadComponent: () =>
      import('./features/empresas/empresas.component').then((m) => m.EmpresasComponent),
    title: 'Chambia para Empresas — Contrata más rápido con IA',
  },
  {
    path: 'vacantes',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/vacantes/vacantes.component').then((m) => m.VacantesComponent),
        title: 'Vacantes — Chambia',
      },
      // /vacantes/categoria/:slug, /vacantes/pais/:slug, /vacantes/ciudad/:slug,
      // y cualquier combinación de esos 3 pares — URLs amigables e indexables
      // por sector/país/ciudad en vez de /vacantes?sector=<id>.
      vacantesFiltradasRoute,
      // Forma nueva/canónica del detalle de una vacante: /vacantes/:paisCode/:slug
      // (ej. /vacantes/mx/analista-de-it-...). El :paisCode es puramente
      // informativo/SEO — la resolución real sigue siendo por slug solo (ver
      // VacanteDetailComponent), así que no requiere cambios de backend ni
      // redirects. La forma vieja /vacantes/:slug (sin país) se conserva abajo
      // funcionando para siempre, para no romper links ya indexados/compartidos.
      {
        path: ':paisCode/:slug',
        loadComponent: () =>
          import('./features/vacante-detail/vacante-detail.component').then(
            (m) => m.VacanteDetailComponent
          ),
      },
      {
        path: ':slug',
        loadComponent: () =>
          import('./features/vacante-detail/vacante-detail.component').then(
            (m) => m.VacanteDetailComponent
          ),
      },
    ],
  },
  {
    path: 'mis-aplicaciones',
    loadComponent: () =>
      import('./features/mis-aplicaciones/mis-aplicaciones.component').then(
        (m) => m.MisAplicacionesComponent
      ),
    title: 'Mis aplicaciones — Chambia',
  },
  {
    path: 'vacantes-guardadas',
    loadComponent: () =>
      import('./features/vacantes-guardadas/vacantes-guardadas.component').then(
        (m) => m.VacantesGuardadasComponent
      ),
    title: 'Vacantes guardadas — Chambia',
  },
  {
    path: 'terminos',
    loadComponent: () =>
      import('./features/legal/terminos.component').then((m) => m.TerminosComponent),
    title: 'Términos y condiciones — Chambia',
  },
  {
    path: 'privacidad',
    loadComponent: () =>
      import('./features/legal/privacidad.component').then((m) => m.PrivacidadComponent),
    title: 'Política de privacidad — Chambia',
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
    title: 'Página no encontrada — Chambia',
  },
];

